import * as actionTypes from '../../actionTypes';

// js utility library
import _ from 'lodash';

export const initialState = {
  isQualified: 'unsubmitted',
  passwordIsReady: false,
  alreadyExists: false,
  user: {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    middleName: '',
    nickName: '',
    phoneNumber1: '',
    phoneType1: null,
    phoneNumber2: '',
    phoneType2: null,
    phoneNumber3: '',
    phoneType3: null,
    address: '',
    city: '',
    zip: '',
    country: '',
    countryOther: null,
    state: null,
    timezone: null,
    bestContactTime: null
  },
  profile: {
    employmentStatus: null,
    availabilityDate: '',
    totalYearsExperience: null,
    industryYearsExperience: null,
    workedLastInIndustry: null,
    industryTypes: [],
    foundUsVia: null,
    foundUsOther: '',
    optIntoNewsletter: false,
    mostRecentSegment: null,
    mostRecentPosition: null,
    mostRecentDepartment: null
  }
};

function overwriteDeep(object, overwriteObject) {
  Object.keys(overwriteObject).forEach(val =>
    Object.assign(object, {[val]: overwriteObject[val]}));
}

function prelimApplicationReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_PRELIM_FORM :
      const clonedState = _.cloneDeep(state);

      // overwrite shallow properties
      Object.assign(clonedState, _.omit(action, 'user', 'profile', 'type'));

      // overwrite deep properties (if provided)
      if(action.user) {
        overwriteDeep(clonedState.user, action.user);
      }
      if(action.profile) {
        overwriteDeep(clonedState.profile, action.profile);
      }

      // return result
      return clonedState;

    default:
      return state;
  }
}

export default prelimApplicationReducer;



// WEBPACK FOOTER //
// ./shared/redux/reducers/prelimApplication/index.js